import { login,logout,getRolePermssion } from "@/api/user";
import storage from  "@/util/storage";
import { getUserMenu } from "../../api/user";

const user = {
    state: {
        username:'',
        nickname:'',
        token:'',
        checkStatus:'',
        userId:'',
        companyId:'',
        roles:[],
        permissions:[],
        menus:[],
        menuRouteLoaded: false,
    },
    getters: {
        isLogin(state) {
            return state.username !== '' && state.token !== '';
        },
        permissions(state) {
            return state.permissions;
        },
        roles(state) {
            return state.roles;
        },
        menus(state) {
            return state.menus;
        },
        menuRouteLoaded(state) {
            return state.menuRouteLoaded;
        }
        
    },
    mutations: {
        SAVE_USERNAME(state, username) {
            state.username = username;
        },
        SAVE_NICKAME(state, nickname) {
            state.nickname = nickname;
        },
        SAVE_TOKEN(state, token) {
            state.token = token;
        },
        SAVE_CHECKSTATUS(state, checkStatus) {
            state.checkStatus = checkStatus;
        },
        SAVE_USERID(state, userId) {
            state.userId = userId;
        },
        SAVE_COMPANYID(state, companyId) {
            state.companyId = companyId;
        },
        SAVE_ROLES(state, roles) {
            state.roles = roles;
        },
        SAVE_PERMISSIONS(state, permissions) {
            state.permissions = permissions;
        },
        SAVE_MENUS(state, menus) {
            state.menus = menus;
        },
        SAVE_MENUROUTELOADED(state, menuRouteLoaded) {
            state.menuRouteLoaded = menuRouteLoaded;
        }

    },
    actions: {
        LOGIN({commit},user) {//登录
            return new Promise(function(resolve){
                login(user).then(res=>{
                    // console.log('登录',res)
                    let resData = res.data
                    if (resData.code === 1) {
                        commit('SAVE_USERNAME', resData.extend.users.user.username);
                        commit('SAVE_NICKAME', resData.extend.users.user.nickname);
                        commit('SAVE_TOKEN', resData.extend.users.token);
                        commit('SAVE_CHECKSTATUS', resData.extend.users.checkStatus);
                        commit('SAVE_USERID', resData.extend.users.userId);
                        commit('SAVE_COMPANYID', resData.extend.users.companyId);
                        storage.saveSessionObject("loginUser",resData.extend.users)
                    }
                    resolve(res)
                })
            })
            
        },
        GET_ROLE_PERM({commit}) {//获取用户角色和权限
            return new Promise(function(resolve){
                getRolePermssion().then(res=>{
                    // console.log('权限',res)
                    commit("SAVE_ROLES", res.data.extend.rolePermission.roles);
                    commit("SAVE_PERMISSIONS", res.data.extend.rolePermission.perms);
                    resolve(res)
                })
            })
        },
        GET_MENU({commit}) {//获取用户菜单
            return new Promise(function(resolve){
                getUserMenu().then(res=>{
                    // console.log('菜单',res)
                    commit("SAVE_MENUS", res.data.extend.permissions);
                    resolve(res)
                })
            })
        },
        LOGOUT({commit}) {//退出
            return new Promise(function(resolve){
                logout().then(res=>{
                    // console.log('退出',res)
                    commit('SAVE_USERNAME', '');
                    commit('SAVE_NICKAME', '');
                    commit('SAVE_TOKEN', '');
                    commit('SAVE_CHECKSTATUS', '');
                    commit('SAVE_USERID', '');
                    commit('SAVE_COMPANYID', '');
                    storage.remove("loginUser")
                    resolve(res)
                })
            })
            
        },
        RECOVERY_MENUROUTELOADED({commit}) {//恢复VUEX里数据
            commit('SAVE_MENUROUTELOADED', true);
        },

        RECOVERY_USER({commit}) {//恢复VUEX里数据
            let loginUser = storage.getSessionObject('loginUser')
            if (loginUser) {
                //console.log('------',loginUser)
                commit('SAVE_USERNAME', loginUser.user.username);
                commit('SAVE_NICKAME', loginUser.user.nickname);
                commit('SAVE_TOKEN', loginUser.token);
                commit('SAVE_CHECKSTATUS', loginUser.checkStatus);
                commit('SAVE_USERID', loginUser.userId);
                commit('SAVE_COMPANYID', loginUser.companyId);
                commit('SAVE_MENUROUTELOADED', true);
            }

        }

    }
}
export default user